var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{class:[
    'lock-scroll-btn',
    'elevation-0',
    _vm.value && 'lock-active',
    _vm.settings.darkMode === true && 'theme--dark'
  ],attrs:{"fab":"","small":""},on:{"click":function($event){return _vm.$emit('input', !_vm.value)}}},[_c('div',[_c('div',{staticClass:"bar",style:({transform: ("translate3d(" + (_vm.value ? 0 : -3) + "px, 0, 0)")})}),_c('div',{staticClass:"bar",style:({top: '1px', transform: ("translate3d(" + (_vm.value ? 0 :  3) + "px, 0, 0)")})})])])}
var staticRenderFns = []

export { render, staticRenderFns }